module.exports = __webpack_public_path__ + "static/img/cadecc8ace94abe51771132fed84cb79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv6.png
// module id = wsMC
// module chunks = 1